import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { Region } from '@leid/api-locations'
import { FaMapMarkerAlt } from 'react-icons/fa'
import Container from 'app/components/shared/Container'
import { useTranslation } from 'react-i18next'

type LocationBarProps = {
  calculatedRegion: Region | undefined
  onOpenModal: () => void
  isProductDetails?: boolean
}

export const LocationBar = ({ calculatedRegion, onOpenModal, isProductDetails = false }: LocationBarProps) => {
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      direction="row"
      marginTop="0px"
      backgroundColor={isProductDetails ? 'white' : 'updatedLeid.green'}
    >
      <Container>
        <Flex padding="10px 0px" justifyContent="space-between" alignItems="center">
          <Text
            marginTop="0px"
            color={isProductDetails ? 'black' : 'white'}
            fontSize="sm"
            maxWidth={{ base: '150px', md: '400px' }}
            wordBreak="break-word"
          >
            {t('showingEquipmentClosestToYou')}
          </Text>
          <Box display="flex" alignItems="center" gap={2}>
            {calculatedRegion && (
              <Text color={isProductDetails ? 'black' : 'white'} fontSize="sm">
                <Text as="span" fontWeight="bold">
                  {calculatedRegion.name}
                </Text>{' '}
                ({t('calculated')})
              </Text>
            )}
            <Button
              color={isProductDetails ? 'white' : 'updatedLeid.green'}
              backgroundColor={isProductDetails ? 'green.a200' : 'white'}
              fontSize="sm"
              borderRadius="md"
              _hover={{ backgroundColor: 'updatedLeid.black', color: 'updatedLeid.white' }}
              onClick={onOpenModal}
              padding={'18px 10px'}
            >
              {calculatedRegion ? 'Change Location' : 'Select Location'}
              <FaMapMarkerAlt size={20} color="updatedLeid.green" />
            </Button>
          </Box>
        </Flex>
      </Container>
    </Box>
  )
}
